module.exports = __webpack_public_path__ + "static/media/boxing-glove.bc14bbe6.svg";